/**
 * Collecte d'erreurs — côté NAVIGATEUR.
 *
 * Les règles de ce qui sort d'ici vivent dans `lib/observability.ts`. Ne pas
 * régler la collecte ici : le filtre s'applique aux trois environnements
 * (navigateur, serveur, périphérie) et doit rester le même dans les trois.
 *
 * L'enregistrement de session a été RETIRÉ le 01/09 — voir la décision D2ter
 * dans `ARCHITECTURE.md`. Ne pas le réintroduire sans reprendre cette décision.
 */
;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/admin/prestataires/:id\",\"regex\":\"^/admin/prestataires/([^/]+)$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/search/prestataires/:id\",\"regex\":\"^/search/prestataires/([^/]+)$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false}],\"staticRoutes\":[{\"path\":\"/\"},{\"path\":\"/about\"},{\"path\":\"/admin\"},{\"path\":\"/admin/prestataires\"},{\"path\":\"/admin/supervision\"},{\"path\":\"/bienvenue\"},{\"path\":\"/dashboard\"},{\"path\":\"/help\"},{\"path\":\"/lab/harmonisation\"},{\"path\":\"/mon-espace\"},{\"path\":\"/onboarding\"},{\"path\":\"/paiement\"},{\"path\":\"/particulier\"},{\"path\":\"/particulier/onboarding\"},{\"path\":\"/prestataire\"},{\"path\":\"/prestataire/catalogue\"},{\"path\":\"/prestataire/messages\"},{\"path\":\"/prestataire/offres\"},{\"path\":\"/prestataire/onboarding\"},{\"path\":\"/prestataire/profile\"},{\"path\":\"/prestataire/search\"},{\"path\":\"/prestataire/stats\"},{\"path\":\"/search/prestataires\"},{\"path\":\"/settings\"},{\"path\":\"/settings/notifications\"},{\"path\":\"/settings/payments\"},{\"path\":\"/settings/privacy\"}],\"isrRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.3.4";globalThis["_sentryRewritesTunnelPath"] = "/monitoring";import * as Sentry from '@sentry/nextjs';
import { SENTRY_DSN, TRACES_SAMPLE_RATE, beforeSend } from '@/lib/observability';

Sentry.init({
  // Vide ⇒ le SDK ne s'initialise pas et n'envoie rien.
  dsn: SENTRY_DSN,

  // Aucune intégration ajoutée : `replayIntegration()` filmait 10 % des
  // sessions et 100 % de celles qui plantaient.
  integrations: [],

  tracesSampleRate: TRACES_SAMPLE_RATE,

  // Adresse IP, cookies et identifiants ne partent pas avec les événements.
  sendDefaultPii: false,

  // Les journaux d'application partent avec leur contexte, et leur contexte
  // n'est pas filtré à la source. On ne remonte que les erreurs.
  enableLogs: false,

  beforeSend,
});

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
